import { onMounted, ref } from "vue";

export default (contactUs: any) => {
  const x = ref(0);
  const y = ref(0);
  let downX = 0;
  let downY = 0;
  let maxX = 1920;
  let maxY = 1080;
  const isMove = ref(false);
  onMounted(() => {
    // 等待元素加载后执行  否则宽度不对
    setTimeout(() => {
      getMaxInner();
      x.value = maxX;
      y.value = maxY * 0.8;
    }, 100); // 宽度获取有问题  延时获取
  });

  window.addEventListener("resize", () => {
    getMaxInner();
    x.value = maxX;
    y.value = maxY * 0.8;
  });

  document.addEventListener("mouseup", () => {
    document.removeEventListener("mousemove", onMouseMove);
    document.onselectstart = null;
    // 等待点击事件之后更改状态
    setTimeout(() => {
      isMove.value = false;
    });
  });

  const onMouseDown = (e: MouseEvent) => {
    document.onselectstart = () => false;
    document.addEventListener("mousemove", onMouseMove);
    const { pageX, pageY } = e;
    downX = pageX - x.value;
    downY = pageY - y.value;
  };
  const onMouseMove = (e: MouseEvent) => {
    isMove.value = true;
    const { pageX, pageY } = e;
    x.value = scopeControl(pageX - downX, maxX);
    y.value = scopeControl(pageY - downY, maxY);
  };

  const scopeControl = (val: number, limit: number) => {
    if (val <= 0) val = 0;
    else if (val > limit) val = limit;
    return val;
  };
  const getMaxInner = () => {
    maxX = window.innerWidth - contactUs.value.offsetWidth - 10;
    maxY = window.innerHeight - contactUs.value.offsetHeight - 10;
  };
  return { onMouseDown, x, y, isMove };
};
